import { render, staticRenderFns } from "./CompGoFlexTeamRequestCard.vue?vue&type=template&id=21a47550"
import script from "./CompGoFlexTeamRequestCard.vue?vue&type=script&setup=true&lang=js"
export * from "./CompGoFlexTeamRequestCard.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports